import Grid from '@mui/material/Grid';
import Pagination from '@mui/material/Pagination';
import Skeleton from '@mui/material/Skeleton';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ActionsButtons from '/@/components/my-recommendations/actions-buttons';
import MyRecommendationsMobileCard from '/@/components/my-recommendations/mobile-card';
import MyRecommendationsMobileFilter from '/@/components/my-recommendations/mobile-filter';
import MyRecommendationsMobileHeader from '/@/components/my-recommendations/mobile-header';
import MyRecommendationsMobileWithFilter from '/@/components/my-recommendations/mobile-with-filter';
import NoResults from '/@/components/my-recommendations/no-results';
import SnackbarAlert from '/@/components/snackbar-alert';
import { _ } from '/@/locale';
import { setGoBack } from '/@/store/nav/actions';
import useWindowSize from '/@/utils/hooks/window-size';
import styles from '../styles.module.css';

const MyRecommendationsMobile = ({
    rows,
    setFilterRecos,
    filterRecos,
    recommendations,
    count,
    page,
    setPage,
    loading,
}) => {
    const [step, setStep] = useState('step1');
    const [searchInput, setSearchInput] = useState('');
    // For future functionality delete multiples recos in mobile
    const [showButtonDeleteRecos, setShowButtonDeleteRecos] = useState(false);
    const [openSnack, setOpenSnack] = useState(false);
    const [colsNum, setColsNum] = useState(3);
    const windowSize = useWindowSize();
    const dispatch = useDispatch();
    const history = useNavigate();
    const w = windowSize.width;

    useEffect(() => {
        if (w >= 420) setColsNum(3);
        else setColsNum(2);
    }, [w]);

    const handleGoBack = () => {
        if (step === 'step1') {
            setFilterRecos({});
            dispatch(setGoBack(undefined));
            history(-1);
        }
        if (step === 'step2') {
            setStep('step1');
            setFilterRecos({});
        }
        if (step === 'step3') {
            setStep('step2');
        }
    };

    useEffect(() => {
        dispatch(setGoBack(handleGoBack));
        return () => {
            dispatch(setGoBack(undefined));
        };
    }, [step]);

    const headers = [
        { name: _('Creación'), id: 'created' },
        { name: _('Tipo'), id: 'typeLabel' },
        { name: _('Fecha de siembra'), id: 'plantingDate' },
        { name: _('Nombre del lote'), id: 'fieldName' },
        { name: _('Ambiente'), id: 'environment' },
        { name: _('Producto'), id: 'product' },
    ];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const RecosTableMobile = () => {
        if (rows.length === 0)
            return (
                <Grid item xs={11}>
                    <NoResults />
                </Grid>
            );
        return rows.map((row) => {
            return (
                <Grid item xs={12} key={row.id}>
                    <MyRecommendationsMobileCard
                        headers={headers}
                        data={row}
                        cols={colsNum}
                        className={styles.card}
                        setOpenSnack={setOpenSnack}
                        setStep={setStep}
                        setFilterRecos={setFilterRecos}
                        setSearchInput={setSearchInput}
                    />
                </Grid>
            );
        });
    };

    return (
        <Grid container justifyContent='center'>
            {step === 'step1' && (
                <Grid item xs={12} className={styles.marginContainerMyRecos}>
                    <MyRecommendationsMobileHeader
                        searchInput={searchInput}
                        setSearchInput={setSearchInput}
                        setFilterRecos={setFilterRecos}
                        filterRecos={filterRecos}
                        setStep={setStep}
                    >
                        {loading ? (
                            <Grid container flexDirection='column' spacing={2} sx={{ m: 2 }}>
                                {Array.from(new Array(4)).map((_, index) => (
                                    <Grid item key={index}>
                                        <Skeleton variant='rectangular' width='100%' height={250} />
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <Fragment>
                                <RecosTableMobile />
                                <Pagination
                                    size='small'
                                    shape='rounded'
                                    count={Math.ceil(count / 5)}
                                    defaultPage={0}
                                    page={page}
                                    onChange={(ev, page) => handleChangePage(ev, page)}
                                    color='primary'
                                    sx={{
                                        p: 3,
                                        display: 'flex',
                                        justifyContent: 'center',
                                    }}
                                />
                            </Fragment>
                        )}
                    </MyRecommendationsMobileHeader>
                </Grid>
            )}
            {step === 'step2' && (
                <Grid item xs={12} className={styles.marginContainerMyRecos}>
                    <MyRecommendationsMobileFilter
                        recommendations={recommendations}
                        filterRecos={filterRecos}
                        onChangeFilters={setFilterRecos}
                    />
                </Grid>
            )}

            {step === 'step3' && (
                <Grid item xs={12} className={styles.marginContainerMyRecos}>
                    <MyRecommendationsMobileWithFilter
                        filterRecos={filterRecos}
                        setFilterRecos={setFilterRecos}
                        setStep={setStep}
                    >
                        <RecosTableMobile />
                    </MyRecommendationsMobileWithFilter>
                </Grid>
            )}
            <ActionsButtons
                step={step}
                filterRecos={filterRecos}
                setFilterRecos={setFilterRecos}
                setStep={setStep}
                showButtonDeleteRecos={showButtonDeleteRecos}
            />
            <SnackbarAlert openSnack={openSnack} setOpenSnack={setOpenSnack} severity='blue'>
                {_('Recomendación/es eliminada/s correctamente')}
            </SnackbarAlert>
        </Grid>
    );
};

export default MyRecommendationsMobile;
